// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3[data-v-40ab164b] {\n  margin: 40px 0 0;\n}\nul[data-v-40ab164b] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-40ab164b] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-40ab164b] {\n  color: #42b983;\n}\n", ""]);
// Exports
module.exports = exports;
